import { createFileRoute } from "@tanstack/react-router";
import AdminIPLibrary from "@/pages/AdminIPLibrary";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/ip-library/")({
  component: () => (
    <RoleGate allow={['staff']} area="IP Library"><AdminIPLibrary /></RoleGate>
  ),
});
